"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleMaps = void 0;
const React = require("react");
const react_1 = require("react");
const isDeliveryPickedUp_1 = require("../../../../helpers/isDeliveryPickedUp");
const delivery_1 = require("../../../../features/base/ordering/types/delivery");
const GoogleMaps = ({ mapId = "map", center, markers, zoom, controls, apiKey, mapStyleId, width, height, hideUI, deliveryPartnerStatus, isDeliveryDriverWithCar, onMarkerClick, onMarkersCreated, onMarkerHover }) => {
    var _a;
    const mapScr = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    const [map, setMap] = (0, react_1.useState)(null);
    const [currentMarkers, setCurrentMarkers] = (0, react_1.useState)(null);
    const directionsRendererRef = (0, react_1.useRef)(null);
    const isRoutingAllowed = () => {
        return (map &&
            deliveryPartnerStatus !== delivery_1.DeliveryPartnerStatus.ArrivedAtDropoff &&
            deliveryPartnerStatus !== delivery_1.DeliveryPartnerStatus.ArrivedAtPickup);
    };
    const handleScriptLoad = () => {
        const mapControls = Object.assign({
            draggable: false,
            zoomControl: false,
            scrollwheel: false,
            disableDoubleClickZoom: true
        }, (controls || {}));
        let mapOptions = Object.assign({
            center,
            zoom,
            disableDefaultUI: hideUI
        }, Object.assign({}, (mapId && { mapId: mapStyleId })));
        mapOptions = Object.assign(mapOptions, mapControls);
        const googleMap = new google.maps.Map(document.getElementById(mapId), mapOptions);
        setMap(googleMap);
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (!((_a = window.google) === null || _a === void 0 ? void 0 : _a.maps)) {
            return;
        }
        handleScriptLoad();
    }, [(_a = window.google) === null || _a === void 0 ? void 0 : _a.maps]);
    const mapMarkers = (0, react_1.useMemo)(() => {
        // @ts-ignore
        if (!map || !window.google || !Array.isArray(markers)) {
            return;
        }
        if (Array.isArray(currentMarkers)) {
            currentMarkers.forEach(currentMarker => currentMarker.setMap(null));
        }
        const mapMarkers = markers.map(marker => {
            marker.map = map;
            // @ts-ignore
            return new window.google.maps.Marker(marker);
        });
        mapMarkers.forEach(mapMarker => {
            typeof onMarkerClick === "function" &&
                mapMarker.addListener("click", () => onMarkerClick(mapMarker, mapMarkers));
            typeof onMarkerHover === "function" &&
                mapMarker.addListener("mouseover", () => onMarkerHover(mapMarker, mapMarkers));
        });
        typeof onMarkersCreated === "function" && onMarkersCreated(mapMarkers);
        setCurrentMarkers(mapMarkers);
        return mapMarkers;
        // @ts-ignore
    }, [map, markers, window.google]);
    (0, react_1.useEffect)(() => {
        if (!Array.isArray(mapMarkers) || zoom) {
            return;
        }
        const bounds = new google.maps.LatLngBounds();
        mapMarkers.forEach(mapMarker => bounds.extend(mapMarker.getPosition()));
        map.setCenter(bounds.getCenter());
        map.fitBounds(bounds);
    }, [mapMarkers]);
    (0, react_1.useEffect)(() => {
        const google = document.getElementById("google");
        if (google) {
            return;
        }
        const s = document.createElement("script");
        s.id = "google";
        s.type = "text/javascript";
        s.src = mapScr;
        s.async = true;
        s.onload = handleScriptLoad;
        document.body.appendChild(s);
    }, []);
    (0, react_1.useEffect)(() => {
        if (deliveryPartnerStatus) {
            const directionsService = new google.maps.DirectionsService();
            let destination = "retailLocationMarker";
            if ((0, isDeliveryPickedUp_1.isDeliveryPickedUp)(deliveryPartnerStatus)) {
                destination = "customerMarker";
            }
            if (directionsRendererRef.current) {
                directionsRendererRef.current.setMap(null);
            }
            if (isRoutingAllowed()) {
                const { 0: customerMarker, 1: retailLocationMarkerOptions, 2: deliveryDriverMarkerOptions } = currentMarkers;
                const directionsRenderer = new google.maps.DirectionsRenderer({
                    map,
                    suppressMarkers: true,
                    polylineOptions: {
                        strokeColor: "#48AA48",
                        strokeWeight: 5,
                        strokeOpacity: 0.5
                    }
                });
                const requestDirection = {
                    origin: deliveryDriverMarkerOptions === null || deliveryDriverMarkerOptions === void 0 ? void 0 : deliveryDriverMarkerOptions.getPosition(),
                    destination: destination === "retailLocationMarker"
                        ? retailLocationMarkerOptions.getPosition()
                        : customerMarker === null || customerMarker === void 0 ? void 0 : customerMarker.getPosition(),
                    travelMode: isDeliveryDriverWithCar
                        ? google.maps.TravelMode.DRIVING
                        : google.maps.TravelMode.BICYCLING
                };
                directionsRendererRef.current = directionsRenderer;
                directionsService.route(requestDirection, (result, status) => {
                    if (status === google.maps.DirectionsStatus.OK) {
                        directionsRenderer.setDirections(result);
                    }
                    else {
                        console.error("Directions request failed due to " + status);
                    }
                });
            }
        }
    }, [markers, map]);
    return (React.createElement("div", { style: {
            width: width !== undefined ? width : "100%",
            height: height ? height : "100%"
        }, id: mapId }));
};
exports.GoogleMaps = GoogleMaps;
exports.default = exports.GoogleMaps;
//# sourceMappingURL=index.js.map